import { useEffect } from 'react';

const ORIGIN = 'https://emboscale.com';

// Apache 301s /foo → /foo/, so the canonical must be the trailing-slash form —
// otherwise canonical and og:url both point at a redirect.
const withSlash = (p) => (p === '/' ? '/' : p.replace(/\/?$/, '/'));

// ponytail: DOM-effect SEO tags instead of react-helmet — the prerender snapshot
// captures post-effect DOM, so crawlers see these without an extra dependency.
const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const Seo = ({ title, description, path }) => {
  useEffect(() => {
    document.title = title;
    setMeta('name', 'description', description);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', ORIGIN + withSlash(path));
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', ORIGIN + withSlash(path));
  }, [title, description, path]);
  return null;
};

export default Seo;
